const OutlinedTick = () => {
  return (
    <svg
      width="68"
      height="68"
      viewBox="0 0 68 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.49982 25.3596C11.3457 17.4902 17.4902 11.3457 25.3596 9.49982C31.0427 8.16673 36.9573 8.16673 42.6404 9.49982C50.5098 11.3457 56.6543 17.4902 58.5002 25.3596C59.8333 31.0427 59.8333 36.9573 58.5002 42.6404C56.6543 50.5098 50.5098 56.6543 42.6404 58.5002C36.9573 59.8333 31.0427 59.8333 25.3596 58.5002C17.4902 56.6543 11.3457 50.5098 9.49982 42.6405C8.16673 36.9573 8.16673 31.0427 9.49982 25.3596Z"
        stroke="#F2F2F2"
        strokeWidth="2.5"
      />
      <path
        d="M26.208 33.2904L31.8747 38.957L41.7913 28.332"
        stroke="#F2F2F2"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default OutlinedTick;
